export const ContactDetails = [
  { icon: 'fa-solid fa-phone', value: '07506113669', type: 'Phone' },
  {
    icon: 'fas fa-envelope',
    value: 'enquiries@heattechuk.co.uk',
    type: 'Email',
  },
];

export const ContactInfoSections = [
  {
    title: 'Emergency Call-Outs',
    text: '24/7 plumbing support for leaks, bursts, and urgent issues. Call now!',
  },
  {
    title: 'Book a Service',
    text: 'Need a plumber? Schedule an appointment at your convenience.',
  },
  {
    title: 'General Enquiries',
    text: 'Got a question? Our team is here to help—just reach out!',
  },
];
